import { Stack, Typography } from "@mui/material";

export default function DataGridCustomNoRowsOverlay(props) {
	const { message } = props;
	return (
		<Stack sx={{ height: "100%", alignItems: "center", justifyContent: "center" }}>
			<Typography variant="body1">{message}</Typography>
		</Stack>
	);
}